<template>
  <div>
    <div class="p-4 card">
      <div>
        <b><u>Class Report</u></b>
        <i v-if="!usersubgroup_id" style="cursor: pointer; margin-left: 10px; font-size: 16px !important; color: #1ea2ed;" class="fas fa-edit"
          @click="toggleClassReportEdit"></i>
        <br />
      </div>

      <div class="mt-2">
        <ul>
          <li v-for="(report, reportName, index) in classReportGraphs" :key="reportName" class="mb-2">
            <b>{{ index + 1 }}.</b> <span>{{ report.name }}</span>
            <div class="mt-1 ml-3">

              <!-- Statement of Internal Marks -->
              <template v-if="reportName === 'statement_of_internal_marks'">
                <b-form-checkbox v-model="report.showPassPercentage" :disabled="!isClassReportEditing">
                  Course-wise Pass Percentage (Bar Graph)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showFailureCount" :disabled="!isClassReportEditing" class="mt-1">
                  Course-wise Failure Count (Bar Graph)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showClassAvgPerSubject" :disabled="!isClassReportEditing" class="mt-1">
                  Average Mark per Course (Line Chart)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showStudentPerformanceDistribution" :disabled="!isClassReportEditing" class="mt-1">
                  Student Performance Distribution (Histogram)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showPassFailRatio" :disabled="!isClassReportEditing" class="mt-1">
                  Overall Pass vs Fail Ratio (Pie Chart)
                </b-form-checkbox>
              </template>

              <!-- Continuous Evaluation -->
              <template v-if="reportName === 'continuous_evaluation'">
                <b-form-checkbox v-model="report.showHighestAvgLowest" :disabled="!isClassReportEditing">
                  Course-wise Performance Comparison (Highest/Average/Lowest) (Grouped Bar Chart)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showCourseAvgMarks" :disabled="!isClassReportEditing" class="mt-1">
                  Course-wise Class Average Marks (Bar Chart)
                </b-form-checkbox>
                <b-form-checkbox v-model="report.showStudentPerformanceDistribution" :disabled="!isClassReportEditing" class="mt-1">
                  Student Performance Distribution (Histogram)
                </b-form-checkbox>
              </template>

            </div>
          </li>
        </ul>
      </div>
      <div>
        <b-button variant="info" class="m-2" @click="setClassReport()" :disabled="!isClassReportEditing">Update</b-button>
      </div>
    </div>
  </div>
</template>

<script>
const REPORT_DEFAULTS = {
  statement_of_internal_marks: {
    name: 'Statement of Assessment Marks With Result Analysis',
    showPassPercentage: true,
    showFailureCount: true,
    showClassAvgPerSubject: true,
    showStudentPerformanceDistribution: true,
    showPassFailRatio: true,
  },
  continuous_evaluation: {
    name: 'Consolidated Statement of Internal Marks',
    showHighestAvgLowest: true,
    showCourseAvgMarks: true,
    showStudentPerformanceDistribution: true,
  },
};

export default {
  props: ["group_id", "usersubgroup_id"],
  async created() {
    await this.getClassReport();
  },
  data() {
    return {
      isClassReportEditing: false,
      classReportGraphs: {
        statement_of_internal_marks: { ...REPORT_DEFAULTS.statement_of_internal_marks },
        continuous_evaluation: { ...REPORT_DEFAULTS.continuous_evaluation },
      },
    };
  },
  methods: {
    toggleClassReportEdit() {
      this.isClassReportEditing = !this.isClassReportEditing;
      if (!this.isClassReportEditing) {
        this.getClassReport();
      }
    },

    async getClassReport() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/class_report_graphs`;
        const response = await this.$axios.get(url);
        if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
          const data = response.data;
          // Merge stored values with defaults so any missing keys always show as checked
          const merged = {};
          Object.keys(REPORT_DEFAULTS).forEach(key => {
            merged[key] = { ...REPORT_DEFAULTS[key], ...(data[key] || {}), name: REPORT_DEFAULTS[key].name };
          });
          this.classReportGraphs = merged;
        }
      } catch (error) {
        console.error("Error fetching class report settings:", error);
      }
    },

    async setClassReport() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/class_report_graphs`;
        await this.$axios.post(url, { class_report_graphs: this.classReportGraphs });
        this.$toast.success("Updated", { position: "top", duration: 3000 });
        this.isClassReportEditing = false;
      } catch (error) {
        console.error("Error updating class report settings:", error);
        this.$toast.error("Update failed!", { position: "top", duration: 3000 });
      }
    },
  },
};
</script>
